const canBeMovedBackward = (element) =>
  !!element.previousElementSibling && element.tagName === element.previousElementSibling.tagName;

export default canBeMovedBackward;
